import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://jzrxjvkorctjcmhfjlpp.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6cnhqdmtvcmN0amNtaGZqbHBwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQxMTk3NzcsImV4cCI6MjA5OTY5NTc3N30.rLM-rv8UFTKRtv-YhMwTMC6NiA60NM0GHJi4Mm0bfZc'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});